import React from 'react';

import {Trans} from '../../../../../libs/shared/helpers/src/internationalization/react';

export const workflowsTaskTitle = <Trans id="admin-setup-guide-title-explore-rules">Explore rules</Trans>;

export const workflowsTaskDescription = (
  <Trans id="admin-setup-guide-description-explore-rules">
    Workflows is Front&apos;s secret sauce. It automates repetitive processes and saves time.
  </Trans>
);

export const inboxTaskTitle = <Trans id="admin-setup-guide-title-create-inbox">Add a team inbox</Trans>;

export const inboxTaskDescription = (
  <Trans id="admin-setup-guide-description-create-inbox">
    Create a team inbox where your teammates can work on customer communications together.
  </Trans>
);

export const teammatesTaskTitle = (
  <Trans id="admin-setup-guide-title-invite-teammates">Invite teammates</Trans>
);

export const teammatesTaskDescription = (
  <Trans id="admin-setup-guide-description-invite-teammates">
    Invite your team and collaborate together.
  </Trans>
);
